import moment from 'moment';
import { DEFAULT_DATE_PICKER_TIME_FORMAT, DEFAULT_TIME_FORMAT } from '@gtintel/platform-constants';
export function formatDateForApi(requestDate) {
  return moment(requestDate, [DEFAULT_TIME_FORMAT, DEFAULT_DATE_PICKER_TIME_FORMAT]).format(DEFAULT_DATE_PICKER_TIME_FORMAT);
}